import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

import { SkeletonRows } from '@/components/ui/skeleton'
import { FleetStatusBanner } from '../../../components/FleetStatusBanner'
import { QuotesLockNotice } from '../../../components/QuotesLockNotice'
import { TrailersTable } from '../../../components/TrailersTable'
import { Trailer, useTrailers } from '../../../models/equipment'
import { FleetEditMode, rosterEditMode, showsQuotesLock, useCurrentUser } from '../../../models/user'
import { useRosterChangePrompt } from './PolicyChanges/useRosterChangePrompt'

export function Trailers() {
  const { user } = useCurrentUser({ enabled: true })
  const orgId = user?.currentOrg.id
  const { trailers, isLoading } = useTrailers({ orgId, shouldFetchAllPages: true })
  const [selectedTrailers, setSelectedTrailers] = useState<Trailer[]>([])
  const quotesLocked = showsQuotesLock(user, user?.currentOrg.currentInsuranceApplication)
  const mode = rosterEditMode(user, quotesLocked)
  const readOnly = mode === FleetEditMode.LOCKED
  // Under a policy in force, a change here waits for review in a policy change request.
  const { prompt, afterRosterChange } = useRosterChangePrompt(
    mode === FleetEditMode.REVIEWED ? orgId : undefined
  )

  useEffect(() => {
    setSelectedTrailers(trailers)
  }, [trailers])

  function renderContent() {
    if (isLoading || !orgId) {
      return <SkeletonRows />
    }

    return (
      <>
        {quotesLocked && <QuotesLockNotice section="trailers" />}
        {!quotesLocked && mode !== FleetEditMode.EDITABLE && (
          <FleetStatusBanner label="trailers" mode={mode} status={user.currentOrg.status} />
        )}
        <TrailersTable
          trailers={selectedTrailers}
          setTrailers={setSelectedTrailers}
          orgId={orgId}
          addCtaOnTop
          searchable
          readOnly={readOnly}
          onAdd={afterRosterChange}
          onEdit={afterRosterChange}
          onDelete={afterRosterChange}
          onRestore={afterRosterChange}
        />
        {prompt}
      </>
    )
  }

  return (
    <>
      <Helmet>
        <title>Trailers</title>
      </Helmet>
      <div className="flex flex-col gap-5">{renderContent()}</div>
    </>
  )
}
